import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CustomDialogDataComponent } from '../custom-dialog-data/custom-dialog-data.component';
import * as fs from 'file-saver';
import { ApicallService } from '../../services/apicall.service';
import { PermissionService } from '../../services/permission.service';
import { FlashService } from '../../services/flash.service';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
})
export class CustomDialogComponent implements OnInit {
  @Input('dialogType') dialogType;

  @Input('disabledArray') disabledArray;

  @Input('data') data;

  @Output() dialogClicked: EventEmitter<any> = new EventEmitter();
  @Output() dialogClickedParam: EventEmitter<any> = new EventEmitter();
  @Output() triggerRefereshPage: EventEmitter<any> = new EventEmitter();

  campaignName: any = '';f
  feeCodeList: any = [];
  cycle: any;
  campaignType: any;
  financial_year:any;
  cyclesList: any = [];
  finacialyearlist: any = [];
  campaignTypeList: any = [];
  feeCodeArrayList: any = [];
  segToArray: any = [];
  segFromArray: any = [];
  stationsList: any = [];
  isSegment: any = 'YES';
  filename: any;
  year:any;
  selectFile:any;
  schemaName:any;
  disableTax: boolean = false;
  typeValue: string = '';
  monthValue: string = '';

  constructor(
    public dialog: MatDialog,
    public apiCallService: ApicallService,
    public permissionService: PermissionService,
    private flashService: FlashService
  ) { }

  ngOnInit() { }

  openDialog() { }

  editProfile() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Are you sure you want save profile data?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['monthYearId']);
      }
    });
  }

  pushToErp() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: `Do you want to push erp for batch id ${this.data[0]}?`,
        batch_id: this.data[0],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['batch_id']);
      }
    });
  }

  refreshTableData(){
    this.triggerRefereshPage.emit();
  }

  downloadTable($event) {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download csv file?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  downloadAgentDump($event) {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download agent master dump?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  downloadUnmappedDump($event) {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download Unmapped dump?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  bulkAction(value) {
    let message;
    if (value == 1) {
      message = `Do you want to approve ${this.data[0].length} invoices?`;
    } else if (value == 2) {
      message = `Do you want to reject ${this.data[0].length} invoices?`;
    }
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'remark',
        message: message,
        remark: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['remark']);
      }
    });
  }

  downloadInvoices() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        ids: this.data[0],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  configDialog() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: `Do you want to ${this.data[3]
          } invoice back date limit to ${this.data[0]
            .split('-')
            .reverse()
            .join('-')} ?`,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  createCampaign() {
    this.feeCodeList = [];
    this.stationsList = [];
    // console.log(this.cyclesList);
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '90vh',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        campaignName: this.campaignName,
        feeCodeList: this.feeCodeList,
        cycle: this.cycle,
        campaignType: this.campaignType,
        cyclesList: this.cyclesList,
        campaignTypeList: this.campaignTypeList,
        feeCodeArrayList: this.feeCodeArrayList,
        segFromArray: this.segFromArray,
        segToArray: this.segToArray,
        stationsList: this.stationsList,
        isSegment: this.isSegment,
        is_plb: 'NO',
        campaign_sub_type: '0',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        const param = {
          campaignName: result['campaignName'],
          feeCodeList: result['feeCodeList'],
          cycle: result['cycle'],
          campaignType: result['campaignType'],
          stationsList: result['stationsList'],
          isSegment: result['campaignType']==4?"YES":result['isSegment'],
          is_plb: result['is_plb'],
          campaign_sub_type: parseInt(result['campaign_sub_type']),
        };
        this.dialogClicked.emit(param);
        this.feeCodeList = [];
        this.stationsList = [];
      }
    });
  }
  createPLBCampaign() {
    this.feeCodeList = [];
    this.stationsList = [];
    // console.log(this.finacialyearlist);
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '90vh',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        campaignName: 'PLB',
        year:this.year,
        feeCodeList: this.feeCodeList,
        cycle: this.cycle,
        financial_year: this.financial_year,
        finacialyearlist: this.finacialyearlist,
        campaignTypeList: this.campaignTypeList,
        feeCodeArrayList: this.feeCodeArrayList,
        selectFile:this.selectFile
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        // console.log(result["financial_year"]);
        if(result["financial_year"]=='' || result["financial_year"]==undefined){  
            // console.log('Inside foodMaster')  
            this.flashService.show("Financial year is blank Please select Financial year", 3000, "warning"); 
            return; 
        }
        const param = {
          campaignName: result['campaignName'],
          feeCodeList: result['feeCodeList'],
          financial_year: result['financial_year'],
          cycle: 'Yearly',
          selectFile: result['selectFile'][0]['name'],
          // ata.selectFile.item(0).name
          // campaignType: result['campaignType'],
          // campaign_sub_type: parseInt(result['campaign_sub_type']),
        };
        // console.log('Results',param)
        this.dialogClicked.emit(param);
        this.feeCodeList = [];
        this.stationsList = [];
      }
    });
  }

  openChargeCode() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        chargeCodes: this.data,
      },
    });
  }

  feeCodeModel() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        chargeCodes: this.data,
      },
    });
  }

  stationModel() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        segments: this.data,
      },
    });
  }

  raiseInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Are you sure you want raise Invoice?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

 
  raiseURDInvoice() {
    if(this.apiCallService.user.agentType=='I'){
      const dialogRef = this.dialog.open(CustomDialogDataComponent, {
        autoFocus: false,
        maxWidth: '90vh',
        maxHeight: '90vh',
        data: {
          type: this.dialogType,
          message: 'Do you want to Proceed?',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result != undefined && typeof result != 'boolean') {
          this.dialogClicked.emit(result);
        }
      });
    } 
    if(this.apiCallService.user.agentType=='D'){
      const dialogRef = this.dialog.open(CustomDialogDataComponent, {
        autoFocus: false,
        maxWidth: '90vh',
        maxHeight: '90vh',
        data: {
          type: this.dialogType,
          message: 'Do you want to raise Invoice?',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result != undefined && typeof result != 'boolean') {
          this.dialogClicked.emit(result);
        }
      });
    }
  }

  printPdf() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Are you sure you want to print invoice?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  previewPdf() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxWidth: '95vh',
      maxHeight: '90vh',
      data: {
        type: 'previewPdf',
        url: this.data,
      },
    });
  }

  submitInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Are you sure you want to submit invoice?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  agentIncentive() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  generateQuarterSlab() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do want to populate Quarter Slab from Annual?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  validateIncentive() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to validate incentive data?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  deleteCampaign() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        ID: this.data,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['ID']);
      }
    });
  }

  uploadSlabMatrix() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '70vh',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        fileName: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['fileName']);
      }
    });
  }

  uploadDirectFile() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '70vh',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        fileName: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['fileName']);
      }
    });
  }

  uploadMapping() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '70vh',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        fileName: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['fileName']);
      }
    });
  }

  companyupload() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '70vh',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        fileName: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['fileName']);
      }
    });
  }

  approveInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to approve Invoice?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  rejectInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to reject Invoice?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  acknowledgeInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to acknowledge Invoice?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  approveProfile() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to verify agent profile?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  rejectProfile() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to reject agent profile?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  approveCampaign() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to approve campaign?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  rejectCampaign() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to reject campaign?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  calculateIncentive() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to calculate incentive data?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  downloadNoGstInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download invoice?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  generateltdsReport() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to generate ltdc report?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(1);
      }
    });
  }

  downloadNoNGstInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download invoice?',
        id: this.data[0],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['id']);
      }
    });
  }

  incentiveReport() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxWidth: '90vh',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        source: this.data,
      },
    });
  }

  revertCampaign() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxWidth: '90vh',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        step: this.data[0],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['step']);
      }
    });
  }

  downloadErrorReport() {
    // console.log(this.data)
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        message: 'Do you want to download error report?',
        filename: this.data[0]['report_ref']['file_name'],
        filepath: this.data[0]['report_ref']['url'],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        if (result['filepath'] != undefined) {
          this.downloadCertificate(result['filepath'], result['filename']);
        }
      }
    });
  }

  downloadIncentiveReport() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxWidth: '90vh',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        message: `Reports list for month ${this.data[1]} and year ${this.data[2]} :`,
        reports: this.data[0],
      },
    });
  }

  downloadUploadedFile() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      width: '350px',
      maxHeight: '90vh',
      data: {
        type: this.dialogType,
        message: 'Do you want to download the file?',
        filename: this.data[0]['upload_ref']['file_name'],
        filepath: this.data[0]['upload_ref']['url'],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        if (result['filepath'] != undefined) {
          this.downloadCertificate(result['filepath'], result['filename']);
        }
      }
    });
  }

  downloadInvoice() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download invoice?',
        filepath: this.data[0],
        filename: this.data[1],
        invoice_number: `${this.data[3]}_${this.data[2]}`,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.getUrl(
          result['filepath'],
          result['filename'],
          result['invoice_number']
        );
      }
    });
  }

  downloadInvoiceView() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download invoice?',
        filepath: this.data[0],
        invoice_number: `${this.data[2]}_${this.data[1]}`,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.downloadCertificate(result['filepath'], result['invoice_number']);
      }
    });
  }

  downloadExport() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: `Do you want to download ${this.data[1]} file?`,
        filepath: this.data[0],
        filename: this.data[1],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.getUrl(result['filepath'], result['filename'], result['filename']);
      }
    });
  }

  downloadEmailDetails() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: `Do you want to download email details file?`,
        id: this.data,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['id']);
      }
    });
  }

  downloadIncentive() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to download?',
        id: this.data,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // console.log('PNR Repor',result);
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['id']);
      }
    });
  }

  raiseDispute() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '70vh',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        id: this.data[0],
        campaign_id: this.data[1],
        remark: '',
        fileName: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        const param = {
          file_name: result['fileName'],
          remark: result['remark'],
          incentive_id: result['id'],
          campaign_id: result['campaign_id'],
        };
        this.dialogClicked.emit(param);
      }
    });
  }

  viewRaiseDispute() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '450px',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        agent_path: this.data[0],
        admin_path: this.data[1],
        agent_file_name: this.data[2],
        agent_remark: this.data[3],
        staff_remark: this.data[4],
        staff_file_name: this.data[5],
        showStatus: this.data[6],
      },
    });
  }

  resolveDispute() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '70vh',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        incentive_id: this.data[0],
        campaign_id: this.data[1],
        remark: '',
        fileName: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        const param = {
          file_name: result['fileName'],
          remark: result['remark'],
          incentive_id: result['incentive_id'],
          campaign_id: result['campaign_id'],
          status: result['status'],
        };
        this.dialogClicked.emit(param);
      }
    });
  }

  uploadDataFile() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '70vh',
      maxWidth: '90vh',
      data: {
        type: this.dialogType,
        campaign_exe_id: this.data[0],
        direct_upload_id: this.data[1],
        fileName: '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        const param = {
          file_name: result['fileName'],
          campaign_execution_id: result['campaign_exe_id'],
          direct_upload_id: result['direct_upload_id'],
        };
        this.dialogClicked.emit(param);
      }
    });
  }

  deleteUploadFile() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: `Do you want to delete uploaded file for ${this.data[1]} company?`,
        id: this.data[0],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        this.dialogClicked.emit(result['id']);
      }
    });
  }

  cancelDispute() {
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      data: {
        type: 'message',
        message: 'Do you want to cancel raised concern?',
        incentive_id: this.data[0],
        campaign_id: this.data[1],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result == 'object') {
        const param = {
          incentive_id: result['incentive_id'],
          campaign_id: result['campaign_id'],
        };
        this.dialogClicked.emit(param);
      }
    });
  }

  downloadCertificate(data, name) {
    fs.saveAs(data, name);
  }

  // clear cache

  cacheRemove() {
    // console.log('testdwnd')
    const dialogRef = this.dialog.open(CustomDialogDataComponent, {
      autoFocus: false,
      maxHeight: "90vh",
      panelClass: "master",
      data: {
        type: this.dialogType,
        typeValue: this.typeValue,
        monthValue: this.monthValue
      },
    });
    dialogRef.afterClosed().subscribe((result) => {

      // console.log('result',result);

      if (typeof result == "object") {
        if (result["typeValue"] === 'Monthly') {
          if(result["typeValue"]===''){  
            this.flashService.show("Type of is blank" , 3000, "warning");  
            return; 
          }else if(result["monthValue"]===''){ 
            this.flashService.show("Month is blank", 3000, "warning");  
            return; 
          }else if(result["yearValue"]===''){  
            this.flashService.show("Year is blank", 3000, "warning"); 
            return; 
          } 
          this.schemaName = result["monthValue"]+result["yearValue"];
          // console.log('schemaName',this.schemaName);
        }else if(result["typeValue"]==='Public'){
            this.schemaName = 'public';
        }else if(result["typeValue"]===''){  
            this.flashService.show("Type of is blank", 3000, "warning"); 
            return; 
        } 

          // console.log('schemaName',this.schemaName);
        // if(){

        // }

        const param = {
          type: result["typeValue"],
          year: result["yearValue"],
          month: result["monthValue"],
          schemaName:this.schemaName
        };

        this.dialogClickedParam.emit(param);
      }
    });
  }

  getUrl(path, filename, invoice_name) {
    let params;
    const param = {
      path: path,
      filename: filename,
    };
    if (this.permissionService.getPermission(['/user/get_url'])) {
      params = {
        param: param,
        action: '/user/get_url',
      };
    }
    if (this.permissionService.getPermission(['/agent/get_url'])) {
      params = {
        param: param,
        action: '/agent/get_url',
      };
    }
    this.apiCallService.triggerService(params).subscribe((data) => {
      if (data.response_code == 1) {
        if (data.data == undefined) {
          this.flashService.show("Can't find file.", 5000, 'warning');
        } else {
          this.flashService.show(
            'Please wait downloading file.',
            5000,
            'success'
          );
          this.downloadCertificate(data.data, invoice_name);
        }
      }
    });
  }
}
